import type { IUtilityNavItem } from '../types';

export const matchPath = ({
  href,
  path,
  siteUrl,
}: {
  href: string;
  path: string;
  siteUrl: string;
}) => (
  href === `${siteUrl}${path}`
  || href.startsWith(`${siteUrl}${path}/`)
);

export const matchUrl = ({
  href,
  siteParentUrl,
  siteUrl,
}: {
  href: string;
  siteParentUrl: string;
  siteUrl: string;
}) => href.startsWith(siteUrl) || href.startsWith(siteParentUrl);

export const setCurrentMenuItem = ({
  id,
  index,
  pathMatchedMenuItem,
  urlMatchedMenuItem,
}: {
  id: string;
  index: number;
  pathMatchedMenuItem: IUtilityNavItem | undefined;
  urlMatchedMenuItem: IUtilityNavItem | undefined;
}) => {
  if (pathMatchedMenuItem?.id) {
    return pathMatchedMenuItem?.id === id;
  }

  if (urlMatchedMenuItem?.id) {
    return urlMatchedMenuItem?.id === id;
  }

  return index === 0;
};
